<div [formGroup]="fGroup" >
  <div [formGroupName]="fgName" class="checkbox-wrapper">
    <input type="checkbox" [id]="fcName" [formControlName]="fcName" [checked]="checked" [disabled]="disabled" [readOnly]="readonly"
           (click)="onCheckboxClick($event)"
    />
    <ng-content></ng-content>
  </div>
</div>
